
import Vue from 'vue'
import Vuex from 'vuex'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin)
Vue.use(Vuex)


window.wx = Vue.wechat

import {
API_INFO,
APP_FAILURE
} from '../../../config/mutation-types'

import {
API_SHARE_URL,
WECHAT_APPID
} from '../../../config/const'


const state = {
apiInfo: ''
}

const getters = {
setShareInfo: state => state.apiInfo
}



const actions = {
setShareInfo({commit}, options) {
var uri = API_SHARE_URL + "?url=" + encodeURIComponent(window.location.href.split('#')[0]);
var setWxShare = (options) => {
window.wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: options.data.appid, // 必填，公众号的唯一标识
timestamp:options.data.timestamp , // 必填，生成签名的时间戳
nonceStr: options.data.nonceStr, // 必填，生成签名的随机串
signature: options.data.signature,// 必填，签名，见附录1
jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','onMenuShareQZone']
});
window.wx.ready(function(){
var shareInfo = {
title: options.shareInfo.title,
desc: options.shareInfo.desc,
link: options.shareInfo.link, // 分享链接
imgUrl: options.shareInfo.imgUrl, // 分享图标
type: 'link', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function () {

},
cancel: function () {

}
};
wx.onMenuShareTimeline(shareInfo);
wx.onMenuShareAppMessage(shareInfo);
wx.onMenuShareQQ(shareInfo);
wx.onMenuShareWeibo(shareInfo);
wx.onMenuShareQZone(shareInfo);
})
}
return new Promise((resolve, reject) => {
Vue.http.get(uri).then((res, err) => {
resolve(res.data)
}, (res) => {
reject(res.data)
})
}).then((res) => {
commit(API_INFO, res)
setWxShare({
data: res,
shareInfo: options.shareInfo
})
}, (err) => {
commit(APP_FAILURE, '获取微信分享信息失败')
})
}
}

const mutations = {
[API_INFO](state, data) {
state.apiInfo = data
},
[APP_FAILURE](state, data) {
state.apiInfo = data
}
}

export default {
state,
getters,
actions,
mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/share/setShareInfo.js